import React, {Component} from 'react';
import StockRow from '../Components/StockRow';
import '../CSS/stockData.css';
import {stock} from '../Resources/stock';

class StockList extends Component{

    constructor(props){
    super(props)
    this.state ={
    lastTradingDate: null
    }
    }
    componentDidMount(){
        stock.getLastTradingDate().then((data)=>{
            this.setState({
                lastTradingDate:data[0].date,
            })
        })
    }
    render(){
        //gets last trading dates as weekends are non trading days.
        const lastTradingDate = this.state.lastTradingDate;
    return(
        // List of items in  Live StockData Madal to display the stocks according to the companies.
        // To check different company stocks, the ticker value can be changed and the live stock for that company can be obtained
        //For example, for IBM the ticker on google is "IBM", so the ticker can be replaced below and the Modal displays the stock data for IBM
        <ul className = "list-group">
       <label className = "BrandTags"> Apple</label><StockRow ticker = "aapl" lastTradingDate ={lastTradingDate}/><br/><br/>
        <label  className = "BrandTags">Google</label><StockRow ticker = "goog" lastTradingDate ={lastTradingDate}/><br/><br/>
        <label  className = "BrandTags">Microsoft</label><StockRow ticker = "msft" lastTradingDate ={lastTradingDate}/><br/><br/>
        <label  className = "BrandTags">NASDAQ</label><StockRow ticker = "NDAQ" lastTradingDate ={lastTradingDate}/><br/><br/>
        <label  className = "BrandTags">Tesla</label><StockRow ticker = "tsla" lastTradingDate ={lastTradingDate}/><br/><br/>
        </ul>
    )
    }
} 
export default StockList;